import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function Settings() {
  const [settings, setSettings] = useState({});
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  useEffect(() => { loadSettings(); }, []);
  async function loadSettings() { const { data } = await api.get('/settings'); setSettings(data); }

  async function handleSave(key, value) {
    setSuccess(''); setError('');
    try { await api.put('/settings', { key, value }); setSuccess('Configuração salva'); loadSettings(); }
    catch (err) { setError(err.response?.data?.error || 'Erro'); }
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-6"><h1 className="text-xl font-bold tracking-tight">Configurações</h1></div>
      {success && <div className="p-3 rounded-md text-sm mb-4 bg-status-approved/10 text-status-approved border border-status-approved/20">{success}</div>}
      {error && <div className="p-3 rounded-md text-sm mb-4 bg-status-rejected/10 text-status-rejected border border-status-rejected/20">{error}</div>}

      <div className="bg-surface-100 border rounded-md p-6 max-w-[600px] space-y-6">
        <div>
          <label className="block text-sm font-medium text-ink-secondary mb-1">Máximo de versões aprovadas por documento</label>
          <div className="flex gap-2">
            <input className="form-input" type="number" min="1" max="100" value={settings.max_versions ?? 10}
              onChange={(e) => setSettings({ ...settings, max_versions: parseInt(e.target.value) })} />
            <button className="btn btn-sm btn-primary" onClick={() => handleSave('max_versions', settings.max_versions)}>Salvar</button>
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-ink-secondary mb-1">Tamanho máximo de arquivo (bytes)</label>
          <div className="flex gap-2">
            <input className="form-input" type="number" min="1048576" value={settings.max_file_size ?? 52428800}
              onChange={(e) => setSettings({ ...settings, max_file_size: parseInt(e.target.value) })} />
            <button className="btn btn-sm btn-primary" onClick={() => handleSave('max_file_size', settings.max_file_size)}>Salvar</button>
          </div>
          <div className="text-xs text-ink-muted mt-1">Atual: {((settings.max_file_size || 52428800) / 1048576).toFixed(0)} MB</div>
        </div>
        <div>
          <label className="block text-sm font-medium text-ink-secondary mb-1">Tipos de arquivo permitidos (separados por virgula)</label>
          <div className="flex gap-2">
            <input className="form-input" value={(settings.allowed_file_types || []).join(', ')}
              onChange={(e) => setSettings({ ...settings, allowed_file_types: e.target.value.split(',').map((t) => t.trim()).filter(Boolean) })} />
            <button className="btn btn-sm btn-primary" onClick={() => handleSave('allowed_file_types', settings.allowed_file_types)}>Salvar</button>
          </div>
        </div>
      </div>
    </div>
  );
}
